import { useMemo } from "react";

import { ArrowLeftIcon, TickThinIcon } from "components/icons";
import ModalConfirmation from "components/ModalConfirmation";
import BUUnassignedMemberList from "../Table";
import { EmployeeListModal } from "./EmployeeListModal";

import { useUnassignedAccountControllerContext } from "../../Controller";
import { useTranslationContext } from "context/TranslationContext";
import { isObjectHasValue } from "helpers/isObjectHasValue";
const BUUnassignedMember = () => {
  const { t } = useTranslationContext();
  const {
    selectedEmployee,
    openEmployeeMemberModal,
    isSelectedRowExist,
    isLoadingGetBUUnassignedMember,
    buUnassignedMembers,
    searchParams,
    pagination,
    selectedRows,
    isSelectedAllPage,
    openAssignConfirmationModal,
    hasAssignStaffAccess,
    onSort,
    onFilter,
    onChangePage,
    onChangePerPage,
    onRowChecked,
    onSearch,
    onSelectAllCurrentPage,
    onSelectAllPage,
    onOpenSelectEmployeeMemberModal,
    onCloseAssignConfirmationModal,
    onSubmit,
    onClickBack,
    onClickAction,
  } = useUnassignedAccountControllerContext();

  const hasFilter = useMemo(() => {
    return isObjectHasValue(searchParams?.filter, ["idBu"]);
  }, [searchParams]);

  return (
    <>
      <BUUnassignedMemberList
        hasAssignStaffAccess={hasAssignStaffAccess}
        onClickAction={onClickAction}
        isRowSelected={isSelectedRowExist || isSelectedAllPage}
        loading={isLoadingGetBUUnassignedMember}
        topLeftIcon={
          <div
            className="flex items-center p-2 border-gray-200 border rounded-md cursor-pointer"
            onClick={onClickBack}
          >
            <ArrowLeftIcon />
          </div>
        }
        onClickAssignAccountBtn={onOpenSelectEmployeeMemberModal}
        title={t("unassigned_accounts")}
        records={buUnassignedMembers}
        sort={searchParams.sort}
        filter={searchParams.filter}
        pagination={pagination}
        hasCheckbox
        selectedRows={selectedRows}
        isSelectedAllPage={isSelectedAllPage}
        hasFilter={hasFilter}
        onSort={onSort}
        onFilter={onFilter}
        onChangePage={onChangePage}
        onChangePerPage={onChangePerPage}
        onSearch={onSearch}
        onRowChecked={onRowChecked}
        onSelectAllCurrentPage={onSelectAllCurrentPage}
        onSelectAllPage={onSelectAllPage}
      />
      {<EmployeeListModal open={openEmployeeMemberModal} />}
      {openAssignConfirmationModal && (
        <ModalConfirmation
          open={openAssignConfirmationModal}
          color="primary"
          title={t("assign_accounts_confirmation")}
          submitLabel={t("assign")}
          cancelLabel={t("cancel")}
          message={`${t("page.bu.unassigned_account.confirmation_modal_body")} ${selectedEmployee?.name}?`}
          icon={
            <div className="rounded-full bg-primary-50 p-3">
              <TickThinIcon
                width={35}
                height={35}
                className="text-primary-500"
              />
            </div>
          }
          onCancel={onCloseAssignConfirmationModal}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default BUUnassignedMember;
